import React from "react";

import "./role_request_base_modal.less";
import { ROLES } from "@src/constants";
import { CustomTabItem } from "@src/types/antd_types";
import { Modal, Tabs } from "antd";
import RoleRequestModalHeader from "@src/components/role_request_modal_header/role_request_modal_header";

interface RoleRequestBaseModalProps {
  modalVisible: boolean;
  requestId: number;
  requestStatus: string;
  standardRoleName: string;
  tabs: CustomTabItem[];
  actions: React.ReactNode;
  activeTabKey: string;
  handleClose: () => void;
  handleTabChange: (key: string) => void;
  isRequestOutdated: boolean;
  userRole?: typeof ROLES.TEAM_LEAD | typeof ROLES.PROJECT_LEAD;
}

const RoleRequestBaseModal: React.FC<RoleRequestBaseModalProps> = ({
  modalVisible,
  standardRoleName,
  requestStatus,
  requestId,
  tabs,
  actions,
  activeTabKey,
  handleClose,
  handleTabChange,
  isRequestOutdated,
  userRole,
}) => {
  return (
    <Modal
      open={modalVisible}
      centered
      width={1018}
      closable={false}
      maskClosable={false}
      className="role-request-modal"
      onCancel={handleClose}
      destroyOnHidden
      title={
        <RoleRequestModalHeader
          requestId={requestId}
          requestStatus={requestStatus}
          standardRoleName={standardRoleName}
          isRequestOutdated={isRequestOutdated}
          userRole={userRole}
        />
      }
      footer={actions}
    >
      <Tabs
        type="card"
        activeKey={activeTabKey}
        onChange={handleTabChange}
        items={tabs.filter(
          (tab: CustomTabItem) => !tab.isHidden?.(requestStatus)
        )}
      />
    </Modal>
  );
};

export default RoleRequestBaseModal;
